<template lang="html">
    <ul class="main-menu__submenu">
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'Stocks'}" v-bind:class="activeMenu">
                <md-icon>view_stream</md-icon>
                <span>Склады</span>
            </router-link>
        </li>
    </ul>
</template>
<script>
    export default {
        name: 'stock-main-menu',
        sort: 3,
        module: 'stocks',
        created() {},
        computed: {
            activeMenu() {
                let routes = ['Stocks', 'Stock', 'StockWorkers', 'StockWorker'];
                return (routes.indexOf(this.$route.name)+1) ? this.$router.options.settingsLinkActiveClass : '';
            }
        },
        data() {
            return {
                module: 'stocks'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// MainMenu.vue?192a1392